import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import './BioModal.css';

export default function BioModal({ isOpen, onClose, member, t }) {
  // Fermer avec Escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen || !t.bio) return null;

  const bio = t.bio;

  return (
    <>
      {/* Overlay */}
      <div className="bio-modal-overlay" onClick={onClose} />
      
      {/* Modal */}
      <div className="bio-modal">
        <div className="bio-modal-header">
          <div>
            <h2 className="bio-modal-title">{member.name}</h2>
            <p className="bio-modal-subtitle">{member.role}</p>
          </div>
          <button onClick={onClose} className="bio-modal-close">
            <X size={24} />
          </button>
        </div>

        <div className="bio-modal-content">
          {/* Formations */}
          <section className="bio-section">
            <h3 className="bio-section-title">{bio.formations.title}</h3>
            <ul className="bio-list">
              {bio.formations.list.map((formation, idx) => (
                <li key={idx}>{formation}</li>
              ))}
            </ul>
          </section>

          {/* Logements Neufs */}
          <section className="bio-section">
            <h3 className="bio-section-title">{bio.logementsNeufs.title}</h3>
            
            <h4 className="bio-subsection-title">{bio.logementsNeufs.concoursTitle}</h4>
            
            {bio.logementsNeufs.concours.map((projet, idx) => (
              <div key={idx} className="bio-project">
                <h5 className="bio-project-title">{projet.title}</h5>
                {projet.subtitle && <p className="bio-project-subtitle">{projet.subtitle}</p>}
                <ul className="bio-project-details">
                  {projet.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              </div>
            ))}

            <h4 className="bio-subsection-title">{bio.logementsNeufs.projetsTitle}</h4>

            {bio.logementsNeufs.projets.map((projet, idx) => (
              <div key={idx} className="bio-project">
                <h5 className="bio-project-title">{projet.title}</h5>
                {projet.subtitle && <p className="bio-project-subtitle">{projet.subtitle}</p>}
                <ul className="bio-project-details">
                  {projet.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              </div>
            ))}
          </section>

          {/* Tertiaire */}
          <section className="bio-section">
            <h3 className="bio-section-title">{bio.tertiaire.title}</h3>
            
            {bio.tertiaire.projets.map((projet, idx) => (
              <div key={idx} className="bio-project">
                <h5 className="bio-project-title">{projet.title}</h5>
                <ul className="bio-project-details">
                  {projet.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              </div>
            ))}
          </section>

          {/* Logements Individuels */}
          <section className="bio-section">
            <h3 className="bio-section-title">{bio.logementsIndividuels.title}</h3>
            
            {bio.logementsIndividuels.projets.map((projet, idx) => (
              <div key={idx} className="bio-project-compact">
                <p><strong>{projet.title}</strong></p>
                <p className="bio-project-details-inline">{projet.details}</p>
              </div>
            ))}
          </section>

          {/* Concours (si présent dans les traductions) */}
          {bio.concours && (
            <section className="bio-section">
              <h3 className="bio-section-title">{bio.concours.title}</h3>
              
              {bio.concours.projets.map((projet, idx) => (
                <div key={idx} className="bio-project-compact">
                  <p><strong>{projet.title}</strong></p>
                  <p className="bio-project-details-inline">{projet.details}</p>
                </div>
              ))}
            </section>
          )}

          {/* Expérience professionnelle */}
          <section className="bio-section">
            <h3 className="bio-section-title">{bio.experiencePro.title}</h3>
            
            {bio.experiencePro.periods.map((period, idx) => (
              <div key={idx} className="bio-experience">
                <p className="bio-experience-period">{period.years}</p>
                {period.description && (
                  <p className="bio-experience-agencies">{period.description}</p>
                )}
                {period.agencies && (
                  <p className="bio-experience-agencies">{period.agencies}</p>
                )}
              </div>
            ))}
          </section>
        </div>
      </div>
    </>
  );
}